import React from 'react';
import {MenuItem} from './MenuItem';
import Divider from '@material-ui/core/Divider';
import {faLock, faPeopleGroup, faPerson} from '@fortawesome/free-solid-svg-icons';
import {useAppContext} from "../../AppContext";

export const MainMenu = () => {

  const {userInfoData} = useAppContext();

  const menuUsers = !userInfoData ? null :
    <>
      <Divider/>
      <MenuItem path="/users" icon={faPerson} text="Users"/>
      <MenuItem path="/groups" icon={faPeopleGroup} text="Groups"/>
    </>
  ;

  const menuAdmin = !userInfoData ? null :
    <>
      <Divider/>
      <MenuItem path="/admin" icon={faLock} text="Admin"/>
    </>
  ;

  return (
    <div className="MainMenu">
      {/*<MenuItem path="/" icon={faHome} text="Home"/>*/}
      {menuUsers}
      {/*{menuAdmin}*/}
    </div>
  );
};
